<mat-dialog-content class="content" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px">
  <p>{{ 'settings.companies.company-administrator-message' | translate }}</p>
  <p>{{ 'settings.companies.response-receiver' | translate }}</p>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close] routerLink="/Settings/Companies">Ok</button>
</mat-dialog-actions>
